<!-- 范围数据操作 -->
<template>
    <div>
        <div v-if="isLoaded">
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED">
                    <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'"
                        :tabslist="tabForm" @tabs="(val) => { showTabs = val }"
                        @tabHeight="(val) => { mxHeight = val }">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box" v-if="scope.index == 0">
                                <!-- 主要信息 -->
                                <el-form ref="sendDataInfo" :model="sendDataInfo" inline size="mini"
                                    :show-message="false" label-width="150px">
                                    <el-form-item label="分类名称" prop="classId"
                                        :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                        <label slot="label" :style="$common.labelStyle('分类名称')"
                                            v-html="$common.htmlLabel('分类名称')"></label>
                                        <el-cascader ref="elCascader" class="form_codition" :props="{ emitPath: false }"
                                            v-model="sendDataInfo.classId" :options="classifyList"></el-cascader>
                                    </el-form-item>
                                    <el-form-item label="轮播图标题" prop="imgTitle"
                                        :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                        <label slot="label" :style="$common.labelStyle('轮播图标题')"
                                            v-html="$common.htmlLabel('轮播图标题')"></label>
                                        <el-input class="form_codition" v-model.trim="sendDataInfo.imgTitle"></el-input>
                                    </el-form-item>
                                    <el-form-item label="是否首页轮播" prop="imgTitle"
                                        :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                        <label slot="label" :style="$common.labelStyle('是否首页轮播')"
                                            v-html="$common.htmlLabel('是否首页轮播')"></label>
                                        <el-radio-group v-model="sendDataInfo.state">
                                            <el-radio-button :label="0">否</el-radio-button>
                                            <el-radio-button :label="1">是</el-radio-button>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item label="轮播图" prop="imgUrl"
                                        :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                        <label slot="label" :style="$common.labelStyle('轮播图(379*339)')"
                                            v-html="$common.htmlLabel('轮播图(379*339)')"></label>
                                        <input style="display: none;" type="file" id="recordExcel1" name="recordExcel1"
                                            @change="(e) => { fileUpload(1, e.target.files, e.target.files.length, 0, e) }" />
                                        <ul v-if="sendDataInfo.imgUrl" class="upload">
                                            <li>
                                                <i class="el-icon-error del" @click="delRemove(1)"></i>
                                                <cusImage style="width: 40px; height: 40px;"
                                                    :src="`${imgUrl}/${sendDataInfo.imgUrl}`"
                                                    :preview-src-list="[`${imgUrl}/${sendDataInfo.imgUrl}`]">
                                                </cusImage>
                                            </li>
                                        </ul>
                                        <ul v-else class="upload">
                                            <li>
                                                <label for="recordExcel1" class="image_label">
                                                    <i class="el-icon-plus icon"></i>
                                                </label>
                                            </li>
                                        </ul>
                                    </el-form-item>
                                    <el-form-item label="详情图" prop="contentUrl"
                                        :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                        <label slot="label" :style="$common.labelStyle('详情图')"
                                            v-html="$common.htmlLabel('详情图')"></label>
                                        <input style="display: none;" type="file" id="recordExcel" multiple
                                            name="recordExcel"
                                            @change="(e) => { fileUpload(2, e.target.files, e.target.files.length, 0, e) }" />
                                        <ul v-if="sendDataInfo.contentUrl" class="upload">
                                            <li v-for="(val, key) in sendDataInfo.contentUrl.split(',')" :key="key">
                                                <i class="el-icon-error del" @click="delRemove(2, key)"></i>
                                                <cusImage style="width: 40px; height: 40px;" :src="`${imgUrl}/${val}`"
                                                    :preview-src-list="sendDataInfo.contentUrl.split(',').map(val1 => `${imgUrl}/${val1}`)">
                                                </cusImage>
                                            </li>
                                            <li>
                                                <label for="recordExcel" class="image_label">
                                                    <i class="el-icon-plus icon"></i>
                                                </label>
                                            </li>
                                        </ul>
                                        <ul v-else class="upload">
                                            <li>
                                                <label for="recordExcel" class="image_label">
                                                    <i class="el-icon-plus icon"></i>
                                                </label>
                                            </li>
                                        </ul>
                                    </el-form-item>
                                    <el-form-item label="排序" prop="sort">
                                        <label slot="label" :style="$common.labelStyle('排序')"
                                            v-html="$common.htmlLabel('排序')"></label>
                                        <el-input class="form_codition" type="number"
                                            v-model.number="sendDataInfo.sort"></el-input>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>

                <div style="text-align:center; margin-top:20px;">
                    <el-button v-if="dataActionBox.actionType != 2" type="primary" @click="initActionBox">取消</el-button>
                    <el-button type="primary" @click="sendDataAction('sendDataInfo')"
                        v-if="dataActionBox.actionType == 0">保存</el-button>
                    <el-button type="primary" @click="sendDataAction('sendDataInfo')"
                        v-if="dataActionBox.actionType == 1">保存</el-button>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "slideshowAction",
    props: ["actionData"],
    data() {
        //这里存放数据
        return {
            imgUrl: window.global_config.BASE_IMG_URL,
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            classifyList: [],
            sendDataInfo: {
                classId: '',
                imgTitle: '',
                contentUrl: "",
                imgUrl: "",
                sort: 0,
                state: 0,
                id: '',
            },
            tabForm: [],
            showTabs: "",
            isLoaded: false,
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        //删除随货通行
        delRemove(val, key) {
            switch (val) {
                case 1://封面图
                    this.sendDataInfo.imgUrl = ''
                    break;
                case 2://详情图
                    var arr = this.sendDataInfo.contentUrl.split(',')
                    arr.splice(key, 1)
                    this.sendDataInfo.contentUrl = arr.join(',')
                    break;
                default:
                    break;
            }

        },
        //详情图 2 封面图 1
        async fileUpload(val, files, length, index, e) {
            if (length - 1 >= index) {
                const params = {
                    file: files[index]
                }
                const response = await this.$http.uploadFile(params, true)
                if (response.status == 200) {
                    if (val == 2) {//详情图
                        var arr = []
                        if (this.sendDataInfo.contentUrl) {
                            arr = this.sendDataInfo.contentUrl.split(',')
                        }
                        arr.push(response.result[0].fileUrl)
                        this.sendDataInfo.contentUrl = arr.join()
                    } else if (val == 1) {//封面图
                        this.sendDataInfo.imgUrl = response.result[0].fileUrl
                    }
                    this.fileUpload(val, files, length, index + 1, e)
                } else {
                    e.target.value = ""
                    this.$message.error(response.message)
                }
            } else {
                e.target.value = ""
            }
        },
        //确认新增
        sendDataAction(formName1) {
            console.log(this.sendDataInfo);

            this.$refs[formName1].validate((valid) => {
                if (valid) {
                    this.sub();
                } else {
                    this.$message({
                        message: "请完善必填信息",
                        type: "error",
                    });
                    return false;
                }
            });
        },
        async sub() {
            var responseData;
            let sendData = JSON.parse(JSON.stringify(this.sendDataInfo))
            delete sendData.parentIds
            if (this.dataActionBox.actionType == 0) {
                responseData = await this.$http.carouseladd(sendData);
            } else if (this.dataActionBox.actionType == 1) {
                responseData = await this.$http.carouselupdate(sendData);
            }
            if (responseData.status == 200) {
                this.init();
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
                this.$emit("drawerCancel");
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        //取消
        initActionBox() {
            this.init();
            this.$emit("drawerCancel");
        },
        //初始化
        init() {
            for (let key in this.sendDataInfo) {
                if (key == 'state') {
                    this.sendDataInfo[key] = 0;
                } else {
                    this.sendDataInfo[key] = ''
                }
            }
        },
        //父级传入
        openBox(cate, formData, oldData = "") {
            this.showTabs = this.dataActionBox.boxTitle + '字典'

            this.classifyList = this.actionData.classifyList
            this.init();
            if (cate == 0) {
                this.dataActionBox.boxTitle = "新增";
                this.dataActionBox.openMode = "ltr";
            } else if (cate == 1) {
                this.dataActionBox.boxTitle = "编辑";
                this.dataActionBox.openMode = "rtl";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.sendDataInfo[key] = dataInfo[key];
                }
            } else {
                this.dataActionBox.boxTitle = "查看";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.sendDataInfo[key] = dataInfo[key];
                }
            }
            this.filterMainField()
            this.dataActionBox.actionType = cate;
            this.dataActionBox.showStatus = true;
        },
        // 过滤表单不同类型
        filterMainField() {
            this.tabForm = [
                {
                    jciName: this.dataActionBox.boxTitle + '字典',
                    jurconfigform: []
                }
            ]
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.$nextTick(() => {
            this.imgUrl = window.global_config.BASE_IMG_URL
            var params = this.actionData;
            this.openBox(params.cate, params.formData, params.oldData[0]);
            this.isLoaded = true;
        });
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.table_content_box {
    overflow-y: auto;
}

.el-row {
    display: flex;
    flex-wrap: wrap;
    padding-right: 20px;
}

.el-drawer {
    outline: none;
}

/* 上传图片 */
.upload {
    width: 200px;
    list-style: none;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.upload li {
    position: relative;
    width: 42px;
    height: 42px;
    margin-right: 5px;
    margin-bottom: 5px;
    border: 1px solid #dedede;
}

.upload .active_li {
    border: none;
}

.image_label {
    display: block;
    width: 42px;
    height: 42px;
}

.upload li:last-child {
    border: none;
}

.upload li:last-child .image_label {
    border: 1px dashed #838383;
}

.upload li:last-child .image_label:hover {
    border: 1px dashed #409eff;
    cursor: pointer;
}

.upload li:last-child:hover .icon {
    color: #409eff;
}

.upload li .icon {
    color: #838383;
    font-size: 20px;
    margin: 10px 0 0 10px;
}

.del {
    display: none;
    position: absolute;
    top: 0px;
    right: 0px;
    font-size: 14px;
    z-index: 99;
    cursor: pointer;
}

.del:hover {
    color: #409eff;
}

.upload li:hover .del {
    display: inline-block;
}

::v-deep .el-image__error {
    font-size: 7px;
}

::v-deep .cus-image {
    width: 40px !important;
    height: 40px !important;
}

::v-deep .cus-image img {
    width: 40px !important;
    height: 40px !important;
}
</style>
